import axios from 'axios'

export default {
  findAll () {
    return axios.get('/api/v2/notice_collections')
  }
}
